import { SharedFileRequestContextType } from "@wingspanhq/shared-files/dist/lib/interfaces/sharedFileRequest";

export function selectorIsSharedFileDriversLicenseContext(
  contextType: SharedFileRequestContextType | undefined
): boolean {
  return (
    !!contextType && contextType === SharedFileRequestContextType.DriversLicense
  );
}
